import { MouseEvent } from 'react';
import { Button } from '@mercator-gcp/grout';
import AIMarker from 'components/elements/AIMarker';
import { trackAIResearchAssistantInteraction } from 'utils/analytics';
import { ProjectDetailsPageViewSections } from 'utils/analytics/constants';

type Props = {
  projectSlug?: string;
  documentId?: string;
  onClick: () => void;
};

const GenerateDetailsWithAIButton = ({ projectSlug, documentId, onClick }: Props) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    const input = event.target as HTMLElement;
    const buttonText = input.innerText;
    trackAIResearchAssistantInteraction({
      projectId: projectSlug || '',
      documentId: documentId || '',
      clickText: buttonText,
      sectionName: ProjectDetailsPageViewSections.PROJECT_DETAILS,
      subSectionName: projectSlug || documentId || undefined,
    });
    onClick();
  };

  return (
    <Button startAdornment={<AIMarker showLabel={false} />} onClick={handleClick}>
      Run AI Analysis
    </Button>
  );
};

export default GenerateDetailsWithAIButton;
